/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PresentationRequestResult { 
    /**
     * Json Web Token with the PresentationRequest. Format: Header.Payload.Signature.
     */
    jwt?: string;
    /**
     * URI for Mobile App with the JWT PresentationRequest.
     */
    jwtInAppURI?: string;
    /**
     * QR Image in PNG format with the JWT PresentationRequest. Encoded in Base64 format
     */
    jwtInQR?: PresentationRequestResult.JwtInQREnum;
    /**
     * QR Image in PNG format with the GET request to JWT PresentationRequest. Encoded in Base64 format
     */
    getRequestToJwtInQR?: PresentationRequestResult.GetRequestToJwtInQREnum;
}
export namespace PresentationRequestResult {
    export const JwtInQREnum = {
        B52d6cd34: '[B@52d6cd34'
    } as const;
    export type JwtInQREnum = typeof JwtInQREnum[keyof typeof JwtInQREnum];
    export const GetRequestToJwtInQREnum = {
        B715d6168: '[B@715d6168'
    } as const;
    export type GetRequestToJwtInQREnum = typeof GetRequestToJwtInQREnum[keyof typeof GetRequestToJwtInQREnum];
}


